/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import AppSearch from "../../Inputs/AppSearch";
import { CARD_GAP, CARD_TITLE } from "../../../utils/constants";
import CompaniesTable from "../../Table/CompaniesTable";
import AnimatedInput from "../../Inputs/AppAnimatedInput";
import { ButtonType, TextInputType } from "../../../enums/componentEnums";
import AppSelect2 from "../../Inputs/AppSelect2";
import * as Yup from "yup";
import useCustomFormik from "../../../customHooks/useFormik";
import AppInput from "../../Inputs/AppInput";
import {
  companyServiceTypeOptions,
  companyTypeOptions,
  countries,
} from "../../../utils/utils";
import { usePostData } from "../../../customHooks/usePostData";
import { enqueueSnackbar } from "notistack";
import { useQueryClient } from "@tanstack/react-query";
import AppButton from "../../Inputs/AppButton";
import FileUpload from "../../Inputs/FileUpload";
function AdminCompanies() {
  const queryClient = useQueryClient();
  const initialValues = {
    name: "",
    company_type: companyTypeOptions[0].value,
    phone_number: "",
    email: "",
    address: "",
    renewal_date: "",
    service_type: companyServiceTypeOptions[0].value,
    currency: countries[0].currency,
    country: countries[0].key,
    logo: "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Company name is required"),
    company_type: Yup.string().required("Company type is required"),
    phone_number: Yup.string().required("Phone number is required"),
    email: Yup.string().lowercase().required("Email is required"),
    address: Yup.string().required("Company address is required"),
    renewal_date: Yup.string().required("Renewal date is required"),
    service_type: Yup.string().required("Service type is required"),
    currency: Yup.string().required("Currency is required"),
    country: Yup.string().required("Country is required"),
    logo: Yup.string().required("Company logo is required"),
  });

  const onSubmit = (values: any) => {
    mutate(values);
    // mutate({ ...values, users: [] });
  };
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    getFieldProps,
    errors,
    touched,
    isSubmitting,
    setSubmitting,
    resetForm,
    setFieldValue,
  } = useCustomFormik({ initialValues, validationSchema, onSubmit });
  const { mutate } = usePostData("/companies", "POST", {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["/companies", "fetchAllCompanies"],
      });
      setClearNameAndUrl(true);
      enqueueSnackbar("Company added successfully!", { variant: "success" });
      setSubmitting(false);
      resetForm();
    },
    onError: (err) => {
      const errorMessages = Object.values(err.response?.data || {})
        .flat() // Flatten arrays of errors
        .join(" "); // Join all messages into a single string
      enqueueSnackbar(errorMessages || "Error adding company", {
        variant: "error",
      });
      setSubmitting(false);
    },
  });
  const [searchQuery, setSearchQuery] = useState("");
const [clearNameAndUrl, setClearNameAndUrl] = useState(false);
  const handleSearch = (query: string) => {
    setSearchQuery(query);
  };
  // update currency based on country
  useEffect(() => {
    setFieldValue(
      "currency",
      countries.find((country) => country.value === values.country)?.currency ||
        countries[0].currency
    );
  }, [values.country, setFieldValue]);
  return (
    <div className="flex flex-col w-full" style={{ gap: CARD_GAP }}>
      <div className="w-full flex justify-between">
        <h1 className="text-primary-blackMain font-bold text-2xl">Companies</h1>
        <div className="max-w-[80%] sm:max-w-[45%] flex-1">
          <AppSearch onSearch={handleSearch} />
        </div>
      </div>
      <div
        className="w-full flex flex-col lg:flex-row flex-1 lg:min-w-[65%]"
        style={{ gap: CARD_GAP }}
      >
        <CompaniesTable searchQuery={searchQuery} />
        {/* Add company form */}
        <form
          onSubmit={handleSubmit}
          className="flex flex-col max-w-[350px] lg:min-w-[30%] bg-white p-6 border border-l-primary-border shadow-lg rounded-lg"
        >
          <h2 className={CARD_TITLE}>Add Company</h2>

          <div className="w-full gap-6 flex flex-col items-start">
            <AnimatedInput
              {...getFieldProps("name")}
              isErrored={!!errors.name}
              isTouched={!!touched.name}
              errorMessage={errors.name}
              placeholder="Company Name"
            />
            {/* <div
              className={`flex w-full gap-4 items-start`}
            > */}
            <AppSelect2
              {...getFieldProps("company_type")}
              name="company_type"
              value={values.company_type}
              isErrored={!!errors.company_type}
              isTouched={!!touched.company_type}
              errorMessage={errors.company_type}
              label="Company Type"
              options={companyTypeOptions}
            />

            <AppSelect2
              {...getFieldProps("service_type")}
              name="service_type"
              value={values.service_type}
              label="Type of Service"
              options={companyServiceTypeOptions}
            />
            {/* </div> */}
            {/* <div className="flex w-full gap-4 items-start"> */}

            <div className={`flex flex-col gap-2 w-full`}>
              <span className="text-sm text-primary-blackMain font-semibold">
                Select Country
              </span>
              <div
                className={`input-wrapper ${
                  errors.currency ? "border-red-500" : "border-primary-border"
                }`}
              >
                <select
                  name={"country"}
                  value={values.country}
                  defaultValue={countries[0].key}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="cursor-pointer flex items-center h-full w-full justify-center border-none outline-none rounded-md  text-primary-blackLighter"
                >
                  {countries.map((option, index) => (
                    <option key={index} value={option.key}>
                      {option.key}
                    </option>
                  ))}
                </select>
              </div>
              {errors.currency && touched.currency && (
                <span className="text-xs text-red-500 mt-1">
                  {errors.currency as string}
                </span>
              )}
            </div>
            <AppInput
              {...getFieldProps("renewal_date")}
              onChange={handleChange}
              onBlur={handleBlur}
              type={TextInputType.DATE}
              topLabel="Company Renewal Date"
              value={values.renewal_date}
              error={errors.renewal_date as string}
              className={""}
            />
            {/* </div> */}
            <AnimatedInput
              {...getFieldProps("phone_number")}
              isErrored={!!errors.phone_number}
              isTouched={!!touched.phone_number}
              errorMessage={errors.phone_number}
              placeholder="Company Phone Number"
            />
            <AnimatedInput
              {...getFieldProps("email")}
              isErrored={!!errors.email}
              isTouched={!!touched.email}
              errorMessage={errors.email}
              placeholder="Company email address"
            />
            <AnimatedInput
              {...getFieldProps("address")}
              isErrored={!!errors.address}
              isTouched={!!touched.address}
              errorMessage={errors.address}
              placeholder="Company address"
            />

            <div className="w-full flex flex-col gap-4">
              <span className="text-sm text-primary-blackMain font-semibold">
                Company Logo
              </span>
              <FileUpload
                {...getFieldProps("logo")}
                name="logo"
                supportedFormats="JPG, JPEG, PNG"
                clearNameAndUrl={clearNameAndUrl}
                // placeholder="Company Logo"
                accept="image/JPEG, image/PNG, image/JPG"
                isErrored={!!errors.logo}
                isTouched={!!touched.logo}
                errorMessage={errors.logo}
                onChange={(e) => {
                  setFieldValue("logo", e);
                }}
              />
            </div>
            <AppButton
              className={"w-full mt-4"}
              text={isSubmitting ? "" : "Add Company"}
              loader={{
                loading: isSubmitting,
                height: 4,
                width: 4,
              }}
              type={ButtonType.PRIMARY}
              handleClick={handleSubmit}
              disabled={isSubmitting}
            />
          </div>
        </form>
      </div>
    </div>
  );
}

export default AdminCompanies;
